import React from 'react';

import { STATIC_RESOURCES_ROOT } from '../../constants';

class SmartTagComponent extends React.Component {
    componentDidUpdate(prevProps) {
        const { enable } = this.props;

        if (enable) {
            if (!document.getElementById('smarttag-body')) {
                this.initTagScript();
            }
        } else {
            if (document.getElementById('smarttag-body')) {
                document.getElementById('smarttag-body').remove();
            }
            this.deleteSmartTagCookies();
        }
    }

    initTagScript() {
        const body = document.getElementsByTagName('body')[0];
        const bodyScript = document.createElement('script');
        bodyScript.id = 'smarttag-body';
        bodyScript.type = 'text/javascript';
        bodyScript.src = `${STATIC_RESOURCES_ROOT}/scripts/smarttag-body.js`;
        body.appendChild(bodyScript);
    }

    deleteSmartTagCookies() {
        document.cookie = 'atuserid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    }

    render() {
        return null;
    }
}

export default SmartTagComponent;



// WEBPACK FOOTER //
// ./src/components/smarttag/SmartTagComponent.js